import { pickCss } from '@/shared/lib/css-utils';
import { Spinner, Text } from '@/shared/ui';
import { useAgentPanelStore } from '../../model/use-agent-panel-store';
import css from './committing-step.module.scss';

const styles = pickCss(css, css.root);

// Renders frame `igs06`. No footer — the commit pipeline drives the
// transition out of this phase (see `use-generator-commit.ts`).
export const CommittingStep = () => {
  const generatorState = useAgentPanelStore((s) => s.generatorState);
  if (generatorState?.phase !== 'committing') return null;

  const { total, succeeded, currentDayIndex } = generatorState;
  // Width as a percentage so the progress fill scales with the panel
  // instead of pinning to the design's 320 px. Clamped to [0, 100].
  const fillPercent = total > 0 ? Math.min(100, (succeeded / total) * 100) : 0;
  const dayLabel =
    currentDayIndex == null
      ? 'Adding items to itinerary…'
      : `items added to Day ${currentDayIndex + 1}`;

  return (
    <div className={styles()}>
      <div aria-hidden="true" className={css.spinnerSlot}>
        <Spinner size="lg" />
      </div>
      <Text size="lg" weight="semibold">
        {succeeded} of {total}
      </Text>
      <Text size="sm" variant="muted">
        {dayLabel}
      </Text>
      <div
        aria-label="Commit progress"
        aria-valuemax={total}
        aria-valuemin={0}
        aria-valuenow={succeeded}
        className={css.progressTrack}
        role="progressbar"
      >
        <div
          aria-hidden="true"
          className={css.progressFill}
          style={{ width: `${fillPercent}%` }}
        />
      </div>
    </div>
  );
};
